import { ReactElement, useContext } from 'react';

import { CartContext } from '~/contexts/cart';
import { currencyWithCents } from '~/lib/format';

import CheckoutButton from '~/components/cart/cart/CheckoutButton/CheckoutButton';

export default function CheckoutBar(): ReactElement {
  const { cart } = useContext(CartContext);

  const itemLength = cart?.cart_items.length ?? 0;
  const itemText = itemLength === 1 ? '1 item' : `${itemLength} items`;

  return (
    <div className="sticky bottom-0 h-[80px] w-full bg-white shadow-[0_-2px_2px_0_rgba(0,0,0,0.1)] lg:hidden">
      <div className="grid h-full grid-cols-2 p-4">
        <div>
          <div>
            <span className="mr-1 font-bold">Total</span>
            <span
              className="text-grace"
              data-testid="cart-checkoutbar-item-text"
            >
              ({itemText})
            </span>
          </div>
          <div className="font-medium">{currencyWithCents(cart?.total)}</div>
        </div>
        <div className="self-center text-right">
          <CheckoutButton isMobile />
        </div>
      </div>
    </div>
  );
}

export { CheckoutBar };
